import React from "react";

export default function StoriesSkeleton() {
  return (
    <div className="space-y-6 animate-pulse">
      {/* Header */}
      <div className="bg-white rounded-lg border border-gray-200 p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="h-5 w-5 bg-gray-300 rounded"></div>
            <div>
              <div className="h-5 bg-gray-300 rounded w-32 mb-2"></div>
              <div className="h-4 bg-gray-200 rounded w-48"></div>
            </div>
          </div>
          <div className="h-8 bg-gray-300 rounded w-20"></div>
        </div>
      </div>

      {/* AI Generation Card */}
      <div className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-lg border border-indigo-200 p-4">
        <div className="flex items-center space-x-3">
          <div className="flex-shrink-0 p-2 bg-indigo-100 rounded-lg">
            <div className="h-5 w-5 bg-indigo-300 rounded"></div>
          </div>
          <div className="flex-1">
            <div className="h-4 bg-gray-300 rounded w-48 mb-2"></div>
            <div className="h-3 bg-gray-200 rounded w-full mb-2"></div>
            <div className="h-3 bg-gray-200 rounded w-3/4 mb-3"></div>
            <div className="flex space-x-2">
              <div className="h-8 bg-gray-300 rounded w-24"></div>
              <div className="h-8 bg-gray-200 rounded w-28"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Stories List */}
      <div className="bg-white rounded-lg border border-gray-200 p-4">
        <div className="space-y-4">
          <div className="h-5 bg-gray-300 rounded w-32 mb-4"></div>
          
          {/* Skeleton Stories */}
          {[1, 2, 3].map((index) => (
            <div key={index} className="bg-gray-50 rounded-lg p-4 border-l-4 border-indigo-500">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center space-x-2 mb-2">
                    <div className="h-4 bg-indigo-200 rounded w-16"></div>
                    <div className="h-4 bg-gray-200 rounded w-20"></div>
                    <div className="h-4 bg-green-200 rounded w-18"></div>
                  </div>
                  <div className="h-5 bg-gray-300 rounded w-64 mb-2"></div>
                  <div className="h-4 bg-gray-200 rounded w-full mb-2"></div>
                  <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                  <div className="flex items-center space-x-4">
                    <div className="h-3 bg-gray-200 rounded w-16"></div>
                    <div className="h-3 bg-gray-200 rounded w-20"></div>
                    <div className="h-3 bg-gray-200 rounded w-24"></div>
                  </div>
                </div>
                <div className="flex space-x-2">
                  <div className="h-8 bg-gray-300 rounded w-16"></div>
                  <div className="h-8 bg-red-200 rounded w-18"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Progress indicator */}
      <div className="bg-white rounded-lg border border-gray-200 p-4">
        <div className="flex items-center justify-center space-x-2">
          <div className="h-2 w-2 bg-indigo-600 rounded-full animate-bounce"></div>
          <div className="h-2 w-2 bg-indigo-600 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
          <div className="h-2 w-2 bg-indigo-600 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
        </div>
        <p className="text-center text-sm text-gray-600 mt-2">
          Gerando user stories inteligentes com IA...
        </p>
      </div>
    </div>
  );
}